import { FEDERATED_PHOTO_URL_PREFIXES } from '../constants/PhotoUploadConstants';

import type { PhotoProps } from '@zg-rentals/maintenance-utils';

export const isRentalManagerUploadedPhoto = (photo: PhotoProps): boolean =>
  FEDERATED_PHOTO_URL_PREFIXES.some((prefix) => photo.source?.startsWith(prefix) ?? false);

/** Returns the per-photo delete check for a feed floor plan gallery, or undefined to keep the modal's default rules. */
export const getFeedFloorPlanPhotoDeleteCheck = ({
  isFeedFloorPlan,
  isUploadAllowed,
  isPhotoEditBlocked,
}: {
  isFeedFloorPlan: boolean;
  isUploadAllowed: boolean;
  isPhotoEditBlocked: boolean;
}): ((photo: PhotoProps) => boolean) | undefined =>
  isFeedFloorPlan && isUploadAllowed && !isPhotoEditBlocked ? isRentalManagerUploadedPhoto : undefined;
